const messages = {
    errors: {
        name: {
            en: "Please enter your name",
            it: "Inserisci il tuo nome",
            es: ""
        },
        email: {
            en: "Please enter your email",
            it: "Inserisci la tua email",
            es: ""
        },
        validEmail: {
            en: "Please enter a valid email address",
            it: "Inserisci un indirizzo di posta valido",
            es: ""
        },
        message: {
            en: "Please enter your message",
            it: "Inserisci il tuo messaggio",
            es: ""
        },
        send: {
            en: "Failed to send message. Please try again later.",
            it: "Errore nell'invio del messaggio. Per favore riprova più tardi.",
            es: ""
        }
    },
    info: {
        sending: {
            en: "Sending...",
            it: "Invio...",
            es: "Envio..."
        },
        send: {
            en: "Thank you for your message! We will get back to you soon.",
            it: "Grazie per averci contattato! Ti contatteremo a breve.",
            es: ""
        }
    }
};

// Theme toggle functionality
document.addEventListener('DOMContentLoaded', function() {
    // Check for saved theme preference or use system preference
    const themeToggleBtn = document.getElementById('theme-toggle');
    const themeToggleDarkIcon = document.getElementById('theme-toggle-dark-icon');
    const themeToggleLightIcon = document.getElementById('theme-toggle-light-icon');

    // Change the icons inside the button based on previous settings
    if (localStorage.getItem('color-theme') === 'dark' ||
        (!localStorage.getItem('color-theme') && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
        document.documentElement.classList.add('dark');
        themeToggleLightIcon.classList.remove('hidden');
    } else {
        themeToggleDarkIcon.classList.remove('hidden');
    }

    // Toggle theme when button is clicked
    themeToggleBtn.addEventListener('click', function() {
        // Toggle icons
        themeToggleDarkIcon.classList.toggle('hidden');
        themeToggleLightIcon.classList.toggle('hidden');

        // If dark mode is active
        if (document.documentElement.classList.contains('dark')) {
            document.documentElement.classList.remove('dark');
            localStorage.setItem('color-theme', 'light');
        } else {
            document.documentElement.classList.add('dark');
            localStorage.setItem('color-theme', 'dark');
        }
    });

    // Language dropdown functionality
    const languageDropdownButton = document.getElementById('language-dropdown-button');
    const languageDropdown = document.getElementById('language-dropdown');

    if (languageDropdownButton && languageDropdown) {
        // Toggle language dropdown
        languageDropdownButton.addEventListener('click', function() {
            languageDropdown.classList.toggle('hidden');
        });

        // Close language dropdown when clicking outside
        document.addEventListener('click', function(event) {
            if (!languageDropdownButton.contains(event.target) && !languageDropdown.contains(event.target)) {
                languageDropdown.classList.add('hidden');
            }
        });
    }

    // Mobile menu toggle
    const mobileMenuButton = document.getElementById('mobile-menu-button');
    const mobileMenu = document.getElementById('mobile-menu');

    mobileMenuButton.addEventListener('click', function() {
        mobileMenu.classList.toggle('hidden');
    });

    // Close mobile menu when clicking on a link
    document.querySelectorAll('#mobile-menu a').forEach(link => {
        link.addEventListener('click', function() {
            mobileMenu.classList.add('hidden');
        });
    });

    // Form submission handling
    const contactForm = document.getElementById('contact-form');
    if (contactForm) {
        contactForm.addEventListener('submit', function(e) {
            e.preventDefault();

            // Get form values
            const name = document.getElementById('name')?.value.trim();
            const email = document.getElementById('email')?.value.trim();
            const message = document.getElementById('message')?.value.trim();
            const lang = getLangFromURL();

            let isValid = true;
            let submitTextContent = "";

            if (!name) {
                isValid = false;
                showError('name', messages.errors.name[lang ?? "en"]);
            } else {
                clearError('name');
            }

            if (!email) {
                isValid = false;
                showError('email', messages.errors.email[lang ?? "en"]);
            } else if (!isValidEmail(email)) {
                isValid = false;
                showError('email', messages.errors.validEmail[lang ?? "en"]);
            } else {
                clearError('email');
            }

            if (!message) {
                isValid = false;
                showError('message', messages.errors.message[lang ?? "en"]);
            } else {
                clearError('message');
            }

            if (isValid) {
                // Optional: disable submit button during sending
                const submitButton = contactForm.querySelector('button[type="submit"]');
                if (submitButton) {
                    submitTextContent = submitButton.textContent;
                    submitButton.disabled = true;
                    submitButton.textContent = messages.info.sending[lang ?? "en"];
                }

                // Send data via Fetch
                fetch(contactForm.action, {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json'
                        },
                        body: new FormData(contactForm)
                    })
                    .then(response => {
                        if (response.ok) {
                            // Success!
                            showToast('success', messages.info.send[lang ?? "en"]);
                            contactForm.reset();
                        } else {
                            return response.json().then(data => {
                                throw new Error(data.error || messages.errors.send[lang ?? "en"]);
                            });
                        }
                    })
                    .catch(error => {
                        showToast('error', error.message || messages.errors.send[lang ?? "en"]);
                    })
                    .finally(() => {
                        if (submitButton) {
                            submitButton.disabled = false;
                            submitButton.textContent = submitTextContent;
                        }
                    });
            }
        });
    }

    // Helper functions for form validation
    function showError(fieldId, message) {
        const field = document.getElementById(fieldId);
        let errorElement = field.nextElementSibling;

        if (!errorElement || !errorElement.classList.contains('form-error')) {
            errorElement = document.createElement('p');
            errorElement.classList.add('form-error');
            field.parentNode.insertBefore(errorElement, field.nextSibling);
        }

        errorElement.textContent = message;
        field.setAttribute('aria-invalid', 'true');
    }

    function clearError(fieldId) {
        const field = document.getElementById(fieldId);
        const errorElement = field.nextElementSibling;

        if (errorElement && errorElement.classList.contains('form-error')) {
            errorElement.remove();
        }

        field.removeAttribute('aria-invalid');
    }

    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    // Function to show a toast
    function showToast(type, message, duration = 5000) {
        // Get the toast element
        const toast = document.getElementById(`${type}-toast`);

        // Set the message if provided
        if (message) {
            document.getElementById(`${type}-message`).textContent = message;
        }

        // Show the toast
        toast.classList.remove('hidden');
        toast.classList.add('flex');

        // Add entrance animation
        toast.classList.add('translate-y-0', 'opacity-100');
        toast.classList.remove('translate-y-2', 'opacity-0');

        // Auto-hide after duration
        if (duration > 0) {
            setTimeout(() => {
                closeToast(type + '-toast');
            }, duration);
        }
    }

    // Function to close a toast
    function closeToast(toastId) {
        const toast = document.getElementById(toastId);

        // Add exit animation
        toast.classList.add('translate-y-2', 'opacity-0');
        toast.classList.remove('translate-y-0', 'opacity-100');

        // Hide after animation completes
        setTimeout(() => {
            toast.classList.add('hidden');
            toast.classList.remove('flex');
        }, 300);
    }

    function getLangFromURL() {
        const path = window.location.pathname;
        if (path.startsWith('/en')) return 'en';
        if (path.startsWith('/it')) return 'it';
        if (path.startsWith('/es')) return 'es';
        return 'en'; // Default
    }

    // Smooth scrolling for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                window.scrollTo({
                    top: target.offsetTop - 64, // Adjust for header height
                    behavior: 'smooth'
                });
            }
        });
    });
});
